import { lazy } from "react";
import { Outlet, RouteObject } from "react-router-dom";

export enum TransactionsRoutes {
    MAIN = "/transactions",
    SEND_CONFIRMATION = "/send/send-confirmation",
    SEND_DETAILS = "/send/send-details",
    SEND_MAIN = "/send",
    SEND_OTP_CODE_VERIFICATION = "/send/otp",
    SEND_SUCCESS = "/send/send-success",
}

const SendConfirmationPage = lazy(() => import("ui/transactions/pages/SendConfirmationPage/SendConfirmationPage"));
const SendDetailsPage = lazy(() => import("ui/transactions/pages/SendDetailsPage/SendDetailsPage"));
const SendOTPCodeVerificationPage = lazy(() => import("ui/transactions/pages/SendOTPCodeVerificationPage/SendOTPCodeVerificationPage"));
const SendSuccessPage = lazy(() => import("ui/transactions/pages/SendSuccessPage/SendSuccessPage"));
const TransactionsPage = lazy(() => import("ui/transactions/pages/TransactionsPage/TransactionsPage"));

export const useTransactionsRoutes = (): RouteObject[] => {
    return [
        {
            element: <TransactionsPage />,
            path: TransactionsRoutes.MAIN,
        },
        {
            element: <Outlet />,
            path: TransactionsRoutes.SEND_MAIN,
            children: [
                {
                    element: <SendConfirmationPage />,
                    path: TransactionsRoutes.SEND_CONFIRMATION,
                },
                {
                    element: <SendDetailsPage />,
                    path: TransactionsRoutes.SEND_DETAILS,
                },
                {
                    element: <SendOTPCodeVerificationPage />,
                    path: TransactionsRoutes.SEND_OTP_CODE_VERIFICATION,
                },
                {
                    element: <SendSuccessPage />,
                    path: TransactionsRoutes.SEND_SUCCESS,
                },
            ],
        },
    ];
};
